import { Link } from "@inertiajs/react";
import Callout from "@/components/help/Callout";
import Screenshot from "@/components/help/Screenshot";
import SignInCard from "@/components/auth/SignInCard";

export default function GettingStartedTeacher() {
  return (
    <>
      <p>
        As a teacher, you'll spend less than a minute a day on PagePledge: log how long the class read, check who's earned a prize, and you're back to teaching. This is the five-minute orientation.
      </p>

      <h2>Sign in (no password to remember)</h2>
      <p>
        Your school admin already invited you, so there's an account waiting. Click the link in the invitation email, or go to pagepledge.com/sign_in and type the email your admin invited you with. We'll send you a sign-in link.
      </p>
      <Screenshot caption="The sign-in page" padded={false}>
        <div className="p-4 max-w-sm mx-auto">
          <SignInCard email="ms.lee@lincoln.ca" />
        </div>
      </Screenshot>
      <p>
        Sign-in links work for 24 hours and only once. After you click one, you stay signed in for 30 days, so you'll only do this every few weeks.
      </p>

      <Callout variant="note" title="The link expired before I clicked it">
        <p>Go back to the sign-in page and ask for another one. The same email works every time.</p>
      </Callout>

      <h2>Where you'll land</h2>
      <p>
        Right on your classroom dashboard, with your class's minutes, money raised and a <strong>Log minutes</strong> button at the top. If you teach more than one classroom, switch between them with the room buttons at the top of the page.
      </p>
      <Callout variant="warning" title="Don't see a classroom?">
        <p>
          You're on the school but haven't been added to a classroom yet. Ask your school admin to add you to the right rooms.
        </p>
      </Callout>

      <h2>What you can do</h2>
      <p>
        Log reading minutes (for the whole class at once, or for one student), print take-home sheets for your class, mark prizes as handed out when students earn them, set a class goal and classroom rewards, and keep an eye on the leaderboards.
      </p>

      <h2>What's left to your school admin</h2>
      <p>
        Adding or removing students, editing the campaign, connecting Square, and seeing donation details. If you need any of those, send them a quick message.
      </p>

      <h2>What's next</h2>
      <ul>
        <li><Link href="/help/articles/teacher-classroom-dashboard">Your classroom dashboard</Link>.</li>
        <li><Link href="/help/articles/logging-classroom-minutes">Logging reading minutes</Link>.</li>
        <li><Link href="/help/articles/handing-out-student-prizes">Handing out student prizes</Link>.</li>
      </ul>
    </>
  );
}
